import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { CORPORATION_IDS_TO_EXCLUDE_NON_US_ADDRESSES } from './constants';
import { ListSourceRecordsFilters, SourceRecordListResponse } from './types';

const formatArrayToString = (value: string | string[]): string => {
  if (Array.isArray(value)) {
    return value.join(',');
  }
  return value;
};

export function useSourceRecords(filters: Partial<ListSourceRecordsFilters>): {
  data: SourceRecordListResponse | undefined;
  error: Error;
  isLoading: boolean;
  mutate: () => void;
} {
  const query = new URLSearchParams();

  const shouldExcludeNonUSAddresses =
    filters.corporationId !== undefined &&
    CORPORATION_IDS_TO_EXCLUDE_NON_US_ADDRESSES.includes(filters.corporationId);

  if (filters.corporationId)
    query.append('corporationId', filters.corporationId.toString());

  if (shouldExcludeNonUSAddresses)
    query.append('includeNonUSAddresses', 'false');

  if (filters.sourcePlatforms && filters.sourcePlatforms.length > 0)
    query.append(
      'sourcePlatforms',
      formatArrayToString(filters.sourcePlatforms)
    );
  if (filters.recordType)
    query.append('recordType', formatArrayToString(filters.recordType));

  if (filters.pipelineStatus && filters.pipelineStatus.length > 0)
    query.append('pipelineStatus', formatArrayToString(filters.pipelineStatus));

  if (filters.approvalState && filters.approvalState.length > 0)
    query.append('approvalState', formatArrayToString(filters.approvalState));

  if (filters.blockCode && filters.blockCode.length > 0)
    query.append('blockCode', formatArrayToString(filters.blockCode));

  if (filters.searchTerm) query.append('searchTerm', filters.searchTerm);

  if (filters.limit) query.append('limit', filters.limit.toString());

  if (filters.cursor) query.append('cursor', filters.cursor);

  const { data, error, isLoading, mutate } = useSWR<{
    success: boolean;
    data: SourceRecordListResponse;
  }>(
    `new-sales-tax/source-record/list?${query}`,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data: data?.data,
    error,
    isLoading,
    mutate,
  };
}
